import * as React from 'react';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { buildClassnames } from './header-region';
export var BaseHeader = function (props) {
  var className = props.className,
    children = props.children;
  var classes = buildClassnames('site-header', className);
  return React.createElement(EGDSSpacing, {
    padding: {
      block: 'four'
    }
  }, React.createElement("header", {
    className: classes
  }, children));
};